import {supportUploadFile} from "../services/request-manager";

export const support_UploadFile = (totalUpload) => supportUploadFile(totalUpload);